import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AssessmentAttempterService } from 'src/app/assessment-attempter.service';

@Component({
  selector: 'app-assessment-question',
  templateUrl: './assessment-question.component.html',
  styleUrls: ['./assessment-question.component.css'],
  standalone: false
})
export class AssessmentQuestionComponent implements OnInit, OnDestroy {

  constructor(
    private attempterService: AssessmentAttempterService,
    private snackBar: MatSnackBar
  ) {}

  questionObj: any = {};
  selectedOptions: any[] = [];

  ngOnInit(): void {
    this.attempterService.$questionObject.subscribe((data) => {
      if (data && data.length > 0) {
        this.questionObj = JSON.parse(data);
        this.selectedOptions = [];
      } else {
        const currentState: any = JSON.parse(localStorage.getItem('currentState'));
        if (currentState && 'currentQuestion' in currentState) {
          this.questionObj = currentState['currentQuestion'];
          this.selectedOptions = [];
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.questionObj = {};
    this.selectedOptions = [];
  }

  getQuestionMediaLength(): boolean {
    return 'questionMedia' in this.questionObj && this.questionObj['questionMedia'].length > 0;
  }

  checkIfOptionsPresent(): boolean {
    return 'options' in this.questionObj && this.questionObj['options'].length > 0;
  }

  checkIfInOption(option: object, objKey: string): boolean {
    return objKey in option;
  }

  isOptionSelected(optionId: any): boolean {
    return this.selectedOptions.includes(optionId);
  }

  onOptionChange(questionId: any, option: any, isChecked: boolean): void {
    if (isChecked) {
      if (this.questionObj?.multiCorrect === true) {
        if (!this.selectedOptions.includes(option)) {
          this.selectedOptions = [...this.selectedOptions, option];
        }
      } else if (!this.selectedOptions.includes(option)) {
        if (this.selectedOptions.length > 0) {
          this.snackBar.open('There is only a single option correct', 'Dismiss', {
            duration: 3000
          });
        }

        // Missing or false multiCorrect flags make the question single-select.
        // Replace the previous selection with the newly checked option.
        this.selectedOptions = [option];
      }
    } else {
      this.selectedOptions = this.selectedOptions.filter(o => o !== option);
    }

    const optionsObject = {
      questionId,
      selectedOptions: this.selectedOptions
    };
    this.attempterService.publishSelectOptions(JSON.stringify(optionsObject));
  }
}
